module.exports = __webpack_public_path__ + "img/IVECO.a8cbd4a9.svg";